import { Box, Skeleton } from '@mui/material';

interface Props {
  width?: number | string;
  labelWidth?: number | string;
  showLabel?: boolean;
}

export const InputSkeleton: React.FC<Props> = ({ width = '100%', labelWidth = 120, showLabel = true }) => (
  <Box sx={{ width }}>
    {showLabel && (
      <Skeleton variant="rectangular" width={labelWidth} height={15} sx={{ mb: '6px', borderRadius: 0.5 }} />
    )}
    <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
  </Box>
);
